import type { IconData } from '@stacksjs/iconify-core'

export const lu4x3: IconData = {
  "body": "<path fill=\"#ed2939\" d=\"M0 0h640v160H0z\"/><path fill=\"#fff\" d=\"M0 160h640v160H0z\"/><path fill=\"#00a1de\" d=\"M0 320h640v160H0z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default lu4x3
